import moment from "moment";

import template from "./pProfitabilityView.html";

import { slugify } from "../../utils/slugify";

export function pProfitabilityViewDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: pProfitabilityViewController,
    controllerAs: 'pProfitabilityView',
    bindToController: true
  };
}

class pProfitabilityViewController {

  constructor(
    $filter,
    $window,
    $location,
    $scope,
    $translate,
    $rootScope,
    $routeParams,
    $interval,
    Auth,
    Stats,
    DownloadFile,
    Bundle,
    Notes,
    ConnectionQuality
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.Auth = Auth;
    this.Stats = Stats;
    this.DownloadFile = DownloadFile;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$window = $window;
    this.$location = $location;
    this.$scope = $scope;
    this.$translate = $translate;
    this.$filter = $filter;
    this.is360visible = false;
    this.div0 = "DIV/0";
    this.na = "N/A";
    this.averageRateState = 'collapsed';
    this.effectiveRateState = 'collapsed';
    this.effectiveRateValue = { min: null, max: null };
    this.averageRateValue = { min: null, max: null };
    this.effectiveRateHourlyCurrency = { min: null, max: null };
    this.averageRateHourlyCurrency = { min: null, max: null };
    this.effectiveRateHourlyEur = { min: null, max: null };
    this.averageRateHourlyEur = { min: null, max: null };
    this.currencyRate = 1;
    this.monthlyIncomes = null;
    this.currencyRates = null;

    this.QUALITY_PERCENTAGE_TIME_REPORTED_MONTHLY = 0;
    this.QUALITY_PERCENTAGE_OPPORTUNITY_TIME = 1;
    this.QUALITY_PERCENTAGE_WORKLOG_ENTRIES_ADDED_MANUALLY = 3;

    this.cumulatedOvertimeAt = "";
    this.Bundle = Bundle;

    this.overtimeSelectedAllColumns = true;
    this.clientsSelectedAllColumns = true;
    this.groupsSelectedAllColumns = true;

    this.isLeader = this.$location.path().startsWith('/stats/team');

    if ($routeParams.from && $routeParams.to) {
      localStorage.setItem(
        this.isLeader
          ? 'roedl-tl-date-pv'
          : 'roedl-m-date-pv'
        , $routeParams.from + '-' + $routeParams.to
      );
    }

    const storedDate = this.isLeader
      ? localStorage.getItem('roedl-tl-date-pv')
      : localStorage.getItem('roedl-m-date-pv');

    this.qualityData = [
      {
        id: "percentageTimeReportedMonthly",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageOfOpportunityTime",
        name: Bundle.getBundleType() === 'roedl' ? this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME") :  this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME_NOT_ROEDL"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_OPPORTUNITY_TIME"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageWorklogsAccepted",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageWorklogsChanged",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: true,
        state: "collapsed"
      }
    ];

    this.headersProfitability = [
      {
        name: this.$translate.instant("STATS.PROFITABILITY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY_RATE")
      },
      {
        name: this.$translate.instant("STATS.AVERAGE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.AVERAGE")
      },
      {
        name: this.$translate.instant("STATS.EFFECTIVE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE")
      }
    ];

    this.$scope.$watch(() => this.currencyRatio, () => this.setupCurrencyRate());
    this.$scope.$watch(() => this.allTablesCurrencyLocal, () => this.setupCurrencyName());
    this.init();

    this.headersTotalOvertimeBasic = [
      {
        name: this.$translate.instant("STATS.REPORTED_OVERTIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.REPORTED_OVERTIME")
      },
      {
        name: this.$translate.instant("STATS.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM")
      },
      {
        name: this.$translate.instant("STATS.CUMULATED_OVERTIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CUMULATED_OVERTIME"),
        appendCumulatedOvertimeAt: true
      }
    ];

    this.headersOvertimeBasic = [
      {
        id: "userName",
        name: this.$translate.instant("STATS.EMPLOYEE"),
        class: "table-info-employee",
        tooltip: this.$translate.instant("STATS.TOOLTIP.EMPLOYEE"),
        sort: "userName",
        overtimeRelated: false,
        visible: true
      },
      {
        id: "percentageTimeReportedMonthly",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        sort: "percentageTimeReportedMonthly",
        overtimeRelated: false,
        visible: true
      },
      {
        id: "percentageOfOpportunityTime",
        name: Bundle.getBundleType() === 'roedl' ? this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME") :  this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME_NOT_ROEDL"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_OPPORTUNITY_TIME"),
        sort: "percentageOfOpportunityTime",
        overtimeRelated: false,
        visible: true
      },
      {
        id: "internalTime",
        name: this.$translate.instant("STATS.INTERNAL_TIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.INTERNAL_TIME"),
        sort: "internalTime",
        visible: true
      },
      {
        id: "percentageWorklogsChanged",
        name: this.$translate.instant("STATS.PERCENTAGE_WORKLOGS_CHANGED"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_WORKLOGS_CHANGED_TOOLTIP"),
        sort: "percentageWorklogsChanged",
        overtimeRelated: false,
        visible: true
      },
      {
        id: "reportedOvertimeDuration",
        name: this.$translate.instant("STATS.REPORTED_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.REPORTED_OVERTIME"),
        sort: "reportedOvertimeDuration",
        overtimeRelated: true,
        visible: true
      },
      {
        id: "acceptedOvertimeDuration",
        name: this.$translate.instant("STATS.ACCEPTED_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM"),
        sort: "acceptedOvertimeDuration",
        overtimeRelated: true,
        visible: true
      },
      {
        id: "cumulatedOvertimeDuration",
        name: this.$translate.instant("STATS.REMAINING_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.CUMULATED_OVERTIME"),
        sort: "cumulatedOvertimeDuration",
        overtimeRelated: true,
        appendCumulatedOvertimeAt: true,
        visible: true
      },
    ];

    this.headersClientGroups = [
      {
        id: "clientGroup",
        name: this.$translate.instant("STATS.CLIENT_GROUP"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_GROUP"),
        class: "table-info-employee",
        sort: "clientGroup",
        visible: true
      },
      {
        id: "effectiveRateHourlyRateRate",
        name: this.$translate.instant("STATS.EFFECTIVE_HOURLY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_HOURLY_RATE"),
        class: "table-number",
        sort: "effectiveRate.hourlyRate.rate",
        visible: true
      },
      {
        id: "effectiveRateRatio",
        name: this.$translate.instant("STATS.EFFECTIVE_PROFITABILITY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_PROFITABILITY_RATE"),
        class: "table-number",
        sort: "effectiveRate.ratio",
        visible: true
      },
      {
        id: "turnover",
        name: this.$translate.instant("STATS.TURNOVER"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TURNOVER"),
        sort: "turnover",
        visible: true
      },
      {
        id: "totalCost",
        name: this.$translate.instant("STATS.TOTAL_COST"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_COST"),
        sort: "totalCost",
        visible: false
      },
      {
        id: "totalMargin",
        name: this.$translate.instant("STATS.TOTAL_MARGIN"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_MARGIN"),
        sort: "totalMargin",
        visible: false
      },
      {
        id: "timeSpentDuration",
        name: this.$translate.instant("STATS.TIME_SPENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.TIME_SPENT"),
        class: "table-date",
        sort: "timeSpentDuration",
        visible: true
      },
      {
        id: "vaToNva",
        name: this.$translate.instant("STATS.VA_PERCENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.VA_PERCENT"),
        class: "table-number",
        sort: "vaToNva",
        visible: true
      },
      {
        id: "mainEmployee",
        name: this.$translate.instant("STATS.MAIN_EMPLOYEE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.MAIN_EMPLOYEE"),
        class: "table-date",
        sort: "mainEmployee",
        visible: true
      },
      {
        id: "numberOfProcessProblems",
        name: this.$translate.instant("STATS.NR_OF_PROCESS_PROBLEMS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.NR_OF_PROCESS_PROBLEMS"),
        class: "table-number",
        sort: "numberOfProcessProblems",
        visible: true
      }
    ];

    this.mapFormatingValue = {
      'effectiveRate': { beName: 'EffectiveHourlyRate', name: 'effectiveRateValue' },
      'averageRate': { beName: 'AverageHourlyRate', name: 'averageRateValue' },
      'percentageWorklogsChanged': { beName: 'WorklogsEntriesAddedManually', index: 3 },
      'percentageWorklogsAccepted': { beName: 'WorklogEntriesAccepted', index: 2 },
      'percentageOfOpportunityTime': { beName: 'OpportunityTime', index: 1 },
      'percentageTimeReportedMonthly': { beName: 'TimeReportedMonthly', index: 0 },
      'averageRateHourlyEur': { beName: 'AverageHourlyRateUniversal', name: 'averageRateHourlyEur' },
      'averageRateHourlyCurrency': { beName: 'AverageHourlyRateLocal', name: 'averageRateHourlyCurrency' },
      'effectiveRateHourlyEur': { beName: 'EffectiveHourlyRateUniversal', name: 'effectiveRateHourlyEur' },
      'effectiveRateHourlyCurrency': { beName: 'EffectiveHourlyRateLocal', name: 'effectiveRateHourlyCurrency' }
    };

    this.saveValue = (rowId, type) => {
      const rootEl = this.mapFormatingValue[rowId];
      var rangeMin;
      var rangeMax;

      if (rootEl.name) {
        rangeMin = Number.parseFloat(this[rootEl.name].min);
        rangeMax = Number.parseFloat(this[rootEl.name].max);

        if (!isNaN(rangeMin) && !isNaN(rangeMax)) {
          if (type === 'min' && rangeMin > rangeMax) {
            this[rootEl.name].max = rangeMin;
            rangeMax = rangeMin;
          }
          else if (type === 'max' && rangeMax < rangeMin) {
            this[rootEl.name].min = rangeMax;
            rangeMin = rangeMax;
          }
        }


        this.Stats.putProfitabilitySettings({
          lowerBound: rangeMin,
          upperBound: rangeMax,
          setting: rootEl.beName
        }
        );
      }
      else if (!isNaN(rootEl.index)) {
        rangeMin = Number.parseFloat(this.qualityData[rootEl.index].rangeMin);
        rangeMax = Number.parseFloat(this.qualityData[rootEl.index].rangeMax);

        if (!isNaN(rangeMin) && !isNaN(rangeMax)) {
          if (type === 'min' && rangeMin > rangeMax) {
            this.qualityData[rootEl.index].rangeMax = rangeMin;
            rangeMax = rangeMin;
          }
          else if (type === 'max' && rangeMax < rangeMin) {
            this.qualityData[rootEl.index].rangeMin = rangeMax;
            rangeMin = rangeMax;
          }
        }
        this.Stats.putProfitabilitySettings({
          lowerBound: rangeMin,
          upperBound: rangeMax,
          setting: rootEl.beName
        }
        );
      }
    };

    this.headersClients = [
      {
        id: "clientName",
        name: this.$translate.instant("STATS.CLIENT_NAME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_NAME"),
        class: "table-info",
        sort: "clientName",
        visible: true
      },
      {
        id: "clientGroup",
        name: this.$translate.instant("STATS.CLIENT_GROUP"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_GROUP_BELONGS"),
        class: "table-number",
        sort: "clientGroup",
        visible: true
      },
      {
        id: "effectiveRateHourlyRateRate",
        name: this.$translate.instant("STATS.EFFECTIVE_HOURLY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_EFFECTIVE_HOURLY_RATE"),
        class: "table-number",
        sort: "effectiveRate.hourlyRate.rate",
        visible: true
      },
      {
        id: "effectiveRateRatio",
        name: this.$translate.instant("STATS.EFFECTIVE_PROFITABILITY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_EFFECTIVE_PROFITABILITY_RATE"),
        class: "table-number",
        sort: "effectiveRate.ratio",
        visible: true
      },
      {
        id: "turnover",
        name: this.$translate.instant("STATS.TURNOVER"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TURNOVER"),
        sort: "turnover",
        visible: true
      },
      {
        id: "totalCost",
        name: this.$translate.instant("STATS.TOTAL_COST"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_COST"),
        sort: "totalCost",
        visible: false
      },
      {
        id: "totalMargin",
        name: this.$translate.instant("STATS.TOTAL_MARGIN"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_MARGIN"),
        sort: "totalMargin",
        visible: false
      },
      {
        id: "timeSpentDuration",
        name: this.$translate.instant("STATS.TIME_SPENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_TIME_SPENT"),
        class: "table-number",
        sort: "timeSpentDuration",
        visible: true
      },
      {
        id: "vaToNva",
        name: this.$translate.instant("STATS.VA_PERCENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_VA_PERCENT"),
        class: "table-number",
        sort: "vaToNva",
        visible: true
      },
      {
        id: "mainEmployee",
        name: this.$translate.instant("STATS.MAIN_EMPLOYEE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_MAIN_EMPLOYEE"),
        class: "table-name",
        sort: "mainEmployee",
        visible: true
      },
      {
        id: "numberOfProcessProblems",
        name: this.$translate.instant("STATS.NR_OF_PROCESS_PROBLEMS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.NR_OF_PROCESS_PROBLEMS"),
        class: "table-number",
        sort: "numberOfProcessProblems",
        visible: true
      }
    ];

    this.headersClientsF = this.headersClients.concat({ class: "table-link" });

    this.state = "loading";

    if (storedDate) {
      let date = storedDate.split("-"); //2018-07-2018-12 -> ['2018','07','2018','12']
      this.dateStartYear = date[0];
      this.dateStartMonth = date[1];
      this.dateEndYear = date[2];
      this.dateEndMonth = date[3];
    } else {
      this.dateEndYear = moment().subtract(1, "month").format("YYYY");
      this.dateEndMonth = moment().subtract(1, "month").format("MM");

      this.dateStartYear = moment().subtract(1, "month").format("YYYY");
      this.dateStartMonth = moment().subtract(1, "month").format("MM");
    }

    this.setColor = (__value, _valueMax, _valueMin, flip) => {
      const value =  parseFloat(__value);
      const valueMax = parseFloat(_valueMax);
      const valueMin = parseFloat(_valueMin);
      const leftColor = flip ? "green" : "red";
      const rightColor = flip ? "red" : "green";

      if (!Number.isFinite(valueMax) && !Number.isFinite(valueMin) || !Number.isFinite(value)) return null;
      else if (Number.isFinite(valueMin) && Number.isFinite(valueMax)) {
        if (value <= valueMin) return leftColor;
        else if (value >= valueMax) return rightColor;
        else if (value > valueMin && value < valueMax) return "yellow";
      }
      else {
        if (Number.isFinite(valueMin)) {
          if (value <= valueMin) return leftColor;
          else return null;
        }
        else if (Number.isFinite(valueMax)) {
          if (value >= valueMax) return rightColor;
          else return null;
        }
      }
      return null;
    };

    this.openProfitabilityRow = (name) => {
      if(this[name] == "collapsed") {
          this[name] = "shown";
      }
      else {
        this[name] = "in-transition";
        setTimeout(() => {
          this[name] = "collapsed";
          this.$scope.$digest(); // wtf? without it it seems so slow and dependant on mouse events
        }, 250);
      }
    };

    this.setRowState = (id, state) => {
      this.qualityData = this.qualityData.map(e => {
        return e.id == id ? { ...e, state: state } : e;
      });
    };

    this.openRow = (id) => {
      const row = this.qualityData.find(e => e.id == id);
      if (row.state == "collapsed") {
        this.setRowState(id, "shown");
      } else {
        this.setRowState(id, "in-transition");
        setTimeout(() => {
          this.setRowState(id, "collapsed");
          this.$scope.$digest(); // wtf? without it it seems so slow and dependant on mouse events
        }, 250);
      }
    };

    this.selectedDates = [this.dateStartMonth, this.dateStartYear, this.dateEndMonth, this.dateEndYear];

    this.updateDateRangeTrigger = (fromMonth, fromYear, toMonth, toYear) => {
      this.dateStartMonth = fromMonth;
      this.dateStartYear = fromYear;
      this.dateEndMonth = toMonth;
      this.dateEndYear = toYear;
      this.updateDateRange();
    };

    const setFlagsAndHeaders = () => {
      this.overtimeManagement = this.user.preferences.featureFlags.some(f => f === "OvertimeManagement");
      this.view360FeatureFlag = this.user.preferences.featureFlags.some(f => f === "View360");
      this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");

      if (this.overtimeApplicationsFlag) {
        this.headersTotalOvertime = [
          ...this.headersTotalOvertimeBasic,
          {
            name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.APPLICATION_OVERTIME"),
          },
          {
            name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.ALLOCATED_APPLICATION_OVERTIME"),
            appendCumulatedOvertimeAt: true
          }
        ];

        this.headersOvertime = [
          ...this.headersOvertimeBasic,
          {
            id: "applicationOvertimeDuration",
            name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
            class: "table-date",
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.APPLICATION_OVERTIME"),
            sort: "applicationOvertimeDuration",
            overtimeRelated: true,
            visible: true
          },
          {
            id: "allocatedApplicationOvertimeDuration",
            name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
            class: "table-date",
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.ALLOCATED_APPLICATION_OVERTIME"),
            sort: "allocatedApplicationOvertimeDuration",
            overtimeRelated: true,
            visible: true,
            appendCumulatedOvertimeAt: true
          }
        ];
      } else {
        this.headersTotalOvertime = [...this.headersTotalOvertimeBasic];
        this.headersOvertime = [...this.headersOvertimeBasic];
      }
    };

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if (!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then(newUserInfo => {
            this.user = newUserInfo;
            setFlagsAndHeaders();
          });
        } else {
          setFlagsAndHeaders();
        }

        this.is360visible = this.view360FeatureFlag && this.user.canAccess360View;

        const preferences = this.user.preferences || {};

        const mapPreferncesToTables = [
          {
            preferncesName: 'tlTablesFliterOvertime',
            tableName: 'headersOvertime'
          },
          {
            preferncesName: 'tlTablesFliterClients',
            tableName: 'headersClients'
          },
          {
            preferncesName: 'tlTablesFliterGroups',
            tableName: 'headersClientGroups'
          }
        ];

        mapPreferncesToTables.forEach( table => {
          if(this.user.preferences.hasOwnProperty(table.preferncesName)) {
            this[table.tableName] = this[table.tableName].map(el => {
              el.visible = this.user.preferences[table.preferncesName].indexOf(el.id) >= 0;
              return el;
            });
          }
        });

        this.overtimeSelectedAllColumns = this.headersOvertime.every(c => c.visible);
        this.clientsSelectedAllColumns = this.headersClients.every(c => c.visible);
        this.groupsSelectedAllColumns = this.headersClientGroups.every(c => c.visible);

        this.refreshProfitabilityView();
        this.qualityTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'qualityTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'qualityTable').isHidden : false;
        this.profitabilityTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'profitabilityTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'profitabilityTable').isHidden : false;
        this.totalOvertimeTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'totalOvertimeTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'totalOvertimeTable').isHidden : false;
        this.averageProfitabilityHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'averageProfitability') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'averageProfitability').isHidden : false;
        this.overtimeTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'overtimeTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'overtimeTable').isHidden : false;
        this.clientGroupsTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'clientGroupsTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'clientGroupsTable').isHidden : false;
        this.clientsTableHidden = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'clientsTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'clientsTable').isHidden : false;
        this.clientGroupsTableCurrencyLocal = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'clientGroupsTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'clientGroupsTable').isLocal : true;
        this.clientsTableCurrencyLocal = preferences.pvTeamLeaderTables && preferences.pvTeamLeaderTables.find((t) => t.table == 'clientsTable') ? preferences.pvTeamLeaderTables.find((t) => t.table == 'clientsTable').isLocal : true;
        this.allTablesCurrencyLocal = this.clientGroupsTableCurrencyLocal;
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }
  setQualityDataValues() {
    if (!this.data) {
      return;
    }
    const keys = Object.keys(this.data);
    keys.forEach(key => {
      switch (key) {
        case 'percentageOfOpportunityTime':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageOfOpportunityTime * 100).toFixed(2)}%`;
          break;
        case 'percentageWorklogsAccepted':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageWorklogsAccepted * 100).toFixed(2)}%`;
          break;
        case 'percentageWorklogsChanged':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageWorklogsChanged * 100).toFixed(2)}%`;
          break;
      }
    });
  }


  init() {
    this.Stats.getProfitabilitySettings().then(success => {
      success.data.map(value => {
        if (value.setting === 'EffectiveHourlyRate') {
          this.effectiveRateValue.min = value.lowerBound;
          this.effectiveRateValue.max = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRate') {
          this.averageRateValue.min = value.lowerBound;
          this.averageRateValue.max = value.upperBound;
        }
        else if (value.setting === 'WorklogsEntriesAddedManually') {
          this.qualityData[3].rangeMin = value.lowerBound;
          this.qualityData[3].rangeMax = value.upperBound;
        }
        else if (value.setting === 'WorklogEntriesAccepted') {
          this.qualityData[2].rangeMin = value.lowerBound;
          this.qualityData[2].rangeMax = value.upperBound;
        }
        else if (value.setting === 'OpportunityTime') {
          this.qualityData[1].rangeMin = value.lowerBound;
          this.qualityData[1].rangeMax = value.upperBound;
        }
        else if (value.setting === 'TimeReportedMonthly') {
          this.qualityData[0].rangeMin = value.lowerBound;
          this.qualityData[0].rangeMax = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRateLocal') {
          this.averageRateHourlyCurrency.min = value.lowerBound;
          this.averageRateHourlyCurrency.max = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRateUniversal') {
          this.averageRateHourlyEur.min = value.lowerBound;
          this.averageRateHourlyEur.max = value.upperBound;
        }
        else if (value.setting === 'EffectiveHourlyRateLocal') {
          this.effectiveRateHourlyCurrency.min = value.lowerBound;
          this.effectiveRateHourlyCurrency.max = value.upperBound;
        }
        else if (value.setting === 'EffectiveHourlyRateUniversal') {
          this.effectiveRateHourlyEur.min = value.lowerBound;
          this.effectiveRateHourlyEur.max = value.upperBound;
        }
      });
    });

    this.Auth.getCustomSetupExchangeRate().then(customSetupExchangeRate =>{
      this.$rootScope.setupRate = customSetupExchangeRate.data;
    });
  }

  refreshProfitabilityView() {
    this.state = "loading";
    this.stateOvertime = "loading";
    this.dataOvertime = {};
    this.currencyRate = 1.0;



    this.Stats.getProfitabilityReport(this.dateStartYear + "-" + this.dateStartMonth, this.dateEndYear + "-" + this.dateEndMonth).then((success) => {
      this.data = this.deserializeProfitabilityData(success.data);
      this.monthlyIncomes = this.data.monthlyIncomes;
      this.setQualityDataValues();
      this.Stats.refreshCurrencyConversions().then((success) => {
        if (this.currenciesError)
            this.currenciesError = false;

        this.currencyRates = success.data;
        this.currencyRate = 1.0 / (this.localToEurRatio || 1.0);
        if(this.data.averageRate.rate && this.data.averageRate.rate.hourlyRate.currency === 'EUR'){
          this.currencyRate = 1.0; 
          this.localToEurRatio = 1.0;
        } else {
          this.Auth.getCustomSetupExchangeRate().then(customSetupExchangeRate =>{
            if (customSetupExchangeRate.status !== 200) {
              this.currencyRate = 1.0;
              this.localToEurRatio = this.data.averageRate.rate ? this.currencyRates[this.data.averageRate.rate.hourlyRate.currency] : '';
            }
            else {
              this.currencyRate = (1/customSetupExchangeRate.data.rate);
              this.localToEurRatio = customSetupExchangeRate.data.rate;
            }
          });
      }}, () => {
        this.currencyRates = {};
        this.currenciesError = true;
      });
      this.prepareChart();
      this.state = "loaded";
    }, (error) => {
      this.state = "error";
      this.error = error;
      this.chartsShown = false;
    });

    this.Stats.getProfitabilityOvertimesReport(this.dateStartYear + "-" + this.dateStartMonth, this.dateEndYear + "-" + this.dateEndMonth).then((success) => {
      this.stateOvertime = "loaded";
      this.dataOvertime = this.deserializeProfitabilityOvertimeData(success.data);
      this.cumulatedOvertimeAt = success.data.cumulatedOvertimeAt;
      const overtimeKeys = Object.keys(this.dataOvertime);
      const overtimeKey = overtimeKeys.find(key => key == 'percentageTimeReportedMonthly');
      this.qualityData.find(el => el.id == overtimeKey).value = `${(this.dataOvertime.percentageTimeReportedMonthly * 100).toFixed(2)}%`;
    }, (error) => {
      this.stateOvertime = "error";
      this.error = error;
    });
  }
  deserializeProfitabilityData(data) {
    var result = angular.copy(data);
    result.clientWithTimeReportedSummary.map((client) => {
      client.timeSpentDuration = moment.duration(client.timeSpent);
      client.totalMargin = client.totalMargin || 0;
      client.totalCost = client.totalCost || 0;

      if (client.additionalInfo)
        client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.clientName}`;
    });

    result.clientWithNoTimeReportedSummary.map((client) => {
      client.effectiveRate = {
        hourlyRate: {
          rate: "DIV/0",
          currency: result.effectiveRate.currency
        },
        ratio: "DIV/0",
        totalMargin: client.totalMargin || 0,
        totalCost: client.totalCost || 0
      };
      client.timeSpent = "PT0S";
      client.timeSpentDuration = moment.duration(client.timeSpent);

      if (client.additionalInfo)
        client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.clientName}`;
    });

    const clientWithNoTimeReportedSummaryButWithIncome = result.clientWithNoTimeReportedSummary.filter(c => c.totalIncome > 0);

    result.clientSummaryAll = result.clientWithTimeReportedSummary.concat(clientWithNoTimeReportedSummaryButWithIncome);

    result.clientGroupSummary.map((group) => {
      group.timeSpentDuration = moment.duration(group.timeSpent);
      group.totalMargin = group.totalMargin || 0;
      group.totalCost = group.totalCost || 0;
    });


    result.clientGroupNoDurationSummary = result.clientGroupNoDurationSummary.map((client) => {
      return {
        clientGroup: client.clientGroup,
        clientGroupId: client.clientGroupId,
        effectiveRate: {
          hourlyRate: {
            rate: "DIV/0",
            currency: result.effectiveRate.currency
          },
          ratio: "DIV/0"
        },
        timeSpent: "PT0S",
        timeSpentDuration: moment.duration(client.timeSpent),
        turnover: client.turnover,
        totalMargin: client.totalMargin || 0,
        totalCost: client.totalCost || 0
      };
    });

    result.clientGroupSummaryAll = result.clientGroupSummary.concat(result.clientGroupNoDurationSummary);

    return result;
  }

  showHeaderOvertimes(header) {
    let show = !header.overtimeRelated || (header.overtimeRelated && this.overtimeManagement);
    let eleFind = this.headersOvertime.find(el => {
      return el.sort === header.sort;
    });
    return show && eleFind.visible;
  }

  showHeaderClients(header) {
    let eleFind = this.headersClients.find(el => {
      return el.sort === header.sort;
    });
    return eleFind.visible;
  }

  showHeadersGroups(header) {
    let eleFind = this.headersClientGroups.find(el => {
      return el.sort === header.sort;
    });
    return eleFind.visible;
  }


  showRow(headers, value) {
    return headers.find(e => {
      return e.id == value;
    }).visible;
  }

  patchPreferences(tableHeadersName, preferncesName) {
    this.overtimeSelectedAllColumns  = this.headersOvertime.every( c => c.visible);
    this.clientsSelectedAllColumns = this.headersClients.every( c => c.visible);
    this.groupsSelectedAllColumns = this.headersClientGroups.every( c => c.visible);

    this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      let arrayVisible = [];

      this[tableHeadersName].forEach(el => {
        if (el.visible) {
          arrayVisible.push(el.id);
        }
      });
      newPreferences[preferncesName] = arrayVisible;
      this.Auth.patchPreferences(newPreferences);
    });
  }

  deserializeProfitabilityOvertimeData(data) {
    var result = angular.copy(data);
    result.overtimeSummary.map((overtime) => {
      overtime.acceptedOvertimeDuration = moment.duration(overtime.acceptedOvertime);
      overtime.reportedOvertimeDuration = moment.duration(overtime.reportedOvertime);
      overtime.cumulatedOvertimeDuration = moment.duration(overtime.cumulatedOvertime);
      overtime.applicationOvertimeDuration = this.$filter("hms")(overtime.applicationOvertime);
      overtime.allocatedApplicationOvertimeDuration = this.$filter("hms")(overtime.allocatedApplicationOvertime);
      overtime.positionTypes = new Set(overtime.positionTypes);
    });
    result.acceptedOvertimeFilter = this.$filter("hms")(result.acceptedOvertime);
    result.reportedOvertimeFilter = this.$filter("hms")(result.reportedOvertime);
    result.cumulatedOvertimeFilter = this.$filter("hms")(result.cumulatedOvertime);
    result.applicationOvertimeFilter = this.$filter("hms")(result.applicationOvertime);
    result.allocatedApplicationOvertimeFilter = this.$filter("hms")(result.allocatedApplicationOvertime);
    return result;
  }

  go360View(type, name) {
    this.selectedDates = [this.dateStartMonth, this.dateStartYear, this.dateEndMonth, this.dateEndYear];
    this.$window.open(`/stats/team/360-view/${type}/${encodeURIComponent(name)}`, 'tl360');
  }

  updateDateRange() {
    let start = this.dateStartYear + "-" + this.dateStartMonth;
    let end = this.dateEndYear + "-" + this.dateEndMonth;

    localStorage.setItem('roedl-tl-date-pv', start + "-" + end);
    this.refreshProfitabilityView();
  }

  prepareChart() {
    angular.element(document).ready(() => {

      this.profitabilityTrendChart = {
        chart: {
          type: 'discreteBarChart',
          noData: this.$translate.instant("NOTHING_TO_SHOW"),
          height: this.data.averageProfitabilityTrend.every(el => el.averageRate == "NotApplicable" || el.averageRate == "DivisionByZero") ? "50" : "200",
          width: Math.min(1100, (100 + this.data.averageProfitabilityTrend.length * 100)).toString(),
          margin: {
            right: 50,
            left: 75
          },
          x: function (d) { return d.label; },
          y: function (d) { return d.value; },
          showValues: true,
          valueFormat: function (d) {
            return d.toFixed(1) + "%";
          },
          transitionDuration: 500,
          xAxis: {
            tickFormat: function (d) {
              return d;
            }
          },
          yAxis: {
            tickFormat: function (d) {
              return d.toFixed(1) + "%";
            }
          }
        },
        data: [{
          key: this.$translate.instant("STATS.AVAREGE_PROFITABILITY_RATE") + " (%)",
          color: "#f00",
          values: this.data.averageProfitabilityTrend.map((el) => {
            return {
              value: el.averageRate.ratio ? el.averageRate.ratio * 100 : 0,
              label: el.yearMonth,
              color: "#00A990"
            };
          })
        }]
      };

      this.chartsShown = true;

      this.$scope.$apply();
    });
  }

  downloadClientGroupExport(clientGroupId, clientGroupName) {
    this.setupCurrencyRate();
    this.state = "loading";
    const from = this.dateStartYear + "-" + this.dateStartMonth;
    const to = this.dateEndYear + "-" + this.dateEndMonth;
    this.Stats.getClientGroupSheetTL(from, to, clientGroupId, this.currencyRate).then(res => {
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers('content-type'),
        `profitability-client-group-export_${from}-${to}-${slugify(clientGroupName)}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  downloadClientExport(clientId, clientName) {
    this.setupCurrencyRate();
    this.state = "loading";
    const from = this.dateStartYear + "-" + this.dateStartMonth;
    const to = this.dateEndYear + "-" + this.dateEndMonth;
    this.Stats.getClientSheetTL(from, to, clientId, this.currencyRate).then(res => {
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers('content-type'),
        `profitability-client-export_${from}-${to}-${slugify(clientName)}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  hideQualityTable() {
    this.qualityTableHidden = !this.qualityTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['qualityTable'], 'isHidden', this.qualityTableHidden);
  }

  hideProfitabilityTable() {
    this.profitabilityTableHidden = !this.profitabilityTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['profitabilityTable'], 'isHidden', this.profitabilityTableHidden);
  }

  hideTotalOvertimeTable() {
    this.totalOvertimeTableHidden = !this.totalOvertimeTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['totalOvertimeTable'], 'isHidden', this.totalOvertimeTableHidden);
  }

  hideAverageProfitability() {
    this.averageProfitabilityHidden = !this.averageProfitabilityHidden;
    this.Stats.changePvTeamLeaderPreferences(['averageProfitability'], 'isHidden', this.averageProfitabilityHidden);
  }

  hideOvertimeTable() {
    this.overtimeTableHidden = !this.overtimeTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['overtimeTable'], 'isHidden', this.overtimeTableHidden);
  }

  hideClientGroupsTable() {
    this.clientGroupsTableHidden = !this.clientGroupsTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['clientGroupsTable'], 'isHidden', this.clientGroupsTableHidden);
  }

  hideClientsTable() {
    this.clientsTableHidden = !this.clientsTableHidden;
    this.Stats.changePvTeamLeaderPreferences(['clientsTable'], 'isHidden', this.clientsTableHidden);
  }

  switchAllCurrencies() {
    this.allTablesCurrencyLocal = !this.allTablesCurrencyLocal;
    this.clientGroupsTableCurrencyLocal = this.allTablesCurrencyLocal;
    this.clientsTableCurrencyLocal = this.allTablesCurrencyLocal;
    this.Stats.changePvTeamLeaderPreferences(['clientGroupsTable', 'clientsTable'], 'isLocal', this.allTablesCurrencyLocal);
  }

  switchClientGroupsTableCurrency() {
    this.clientGroupsTableCurrencyLocal = !this.clientGroupsTableCurrencyLocal;
    this.Stats.changePvTeamLeaderPreferences(['clientGroupsTable'], 'isLocal', this.clientGroupsTableCurrencyLocal);
  }

  switchClientsTableCurrency() {
    this.clientsTableCurrencyLocal = !this.clientsTableCurrencyLocal;
    this.Stats.changePvTeamLeaderPreferences(['clientsTable'], 'isLocal', this.clientsTableCurrencyLocal);
  }

  setupCurrencyName(){
    this.isEuroExchange = !this.allTablesCurrencyLocal;
  }

  setupCurrencyRate(){
    if(this.$rootScope.setupRate !== undefined){
      this.currencyRatio = !this.currencyRatio ? 1/this.$rootScope.setupRate.rate : 1;
      this.localToEurRatio = this.$rootScope.setupRate.rate;
    }
    this.currencyRate = 1/this.localToEurRatio;
  }

  exportClientsReport() {
    this.state = 'loading';

    this.Stats.getClientReport({from: `${this.dateStartYear}-${this.dateStartMonth}`, to: `${this.dateEndYear}-${this.dateEndMonth}`}).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `Clients report ${this.dateStartYear}-${this.dateStartMonth}_${this.dateEndYear}-${this.dateEndMonth}`
        );
        this.state = 'loaded';
      }, (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error});
      }
    );
  }

  exportClientGroupsReport() {
    this.state = 'loading';

    this.Stats.getClientGroupsReport({from: `${this.dateStartYear}-${this.dateStartMonth}`, to: `${this.dateEndYear}-${this.dateEndMonth}`}).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `Client groups report ${this.dateStartYear}-${this.dateStartMonth}_${this.dateEndYear}-${this.dateEndMonth}`
        );
        this.state = 'loaded';
      }, (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error});
      }
    );
  }
}
